/** Sort direction for API search endpoints (mirrors the API `SortDirectionType` enum). */
export enum SortDirectionType {
  Ascending = 1,
  Descending = 2,
}
